export const ROUTES_PATH = {
  ROOT: "/",
  LOGIN: "/login",
  REGISTER: "/register",
  FORGOT_PASSWORD: "/forgot-password",
  UPDATE_PASSWORD: "/update-password",
  ASSETS: "/assets",
  CHAT: "/chat",
  DASHBOARD: "/dashboard",
  PRICING: "/pricing",
  ACCOUNT: "/account",
  PROFILE: "/account/profile",
  BILLING: "/account/billing",
  NOT_FOUND: "*",
};

export const NAVBAR_ROUTES = [
  ROUTES_PATH.DASHBOARD,
  ROUTES_PATH.ASSETS,
  ROUTES_PATH.CHAT,
  ROUTES_PATH.ACCOUNT,
];

export const STATUS_BANNER_ROUTES = [
  ROUTES_PATH.DASHBOARD,
  ROUTES_PATH.ASSETS,
];
